import React from "react";
import CreatorDetails from "../../../pages/ChangeRequest/activities/creatorDetails";
import { ucFirst } from "../../../helpers/string_helper";
import { Action } from "../../../constants/Common";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import { Modules } from "../../../constants/Module";
import { withTranslation } from "react-i18next";
function Risk({ item,t }) {
  return (
    <div>
      <div>
        <strong>
          {" "}
          {ucFirst(Modules.RISK)} ({typeof item?.payload?.name === 'object' ? item?.payload?.name.old : item?.payload?.name}){" "}
        </strong>
         {item.event === Action.CREATE ? t("was added to") : item.event === Action.UPDATE ? t("was updated for") : t("was deleted from")}{" "}
        <strong>
          {t('startup')} {ucFirst(item.project?.name)} (
          {item?.project?.uniqueProjectId})
        </strong>{" "}
        {t('by')}
        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
      </div>
      {item?.event === Action?.UPDATE && (
        <div>
          {typeof item?.payload?.name === 'object' &&
            item?.payload?.name?.old &&
            item?.payload?.name?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Name')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.name?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.name?.new}</span>
                  </div>
                </div>
              </div>
            )}
          {typeof item?.payload?.description === "object" && 
           item?.payload?.description?.old && item?.payload?.description?.new && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Description')}:</strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.description?.old}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.description?.new}
                  </span>
                </div>
              </div>
            </div>
          )}
          {typeof item?.payload?.impact && item?.payload?.impact?.old && item?.payload?.impact?.new && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Impact')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.impact?.old}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.impact?.new}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.probability &&
            item?.payload?.probability?.old &&
            item?.payload?.probability?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Probability')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>
                      {item?.payload?.probability?.old}
                    </span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">
                      {item?.payload?.probability?.new}
                    </span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.priority &&
            item?.payload?.priority?.old &&
            item?.payload?.priority?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Priority')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>
                      {item?.payload?.priority?.old}
                    </span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">
                      {item?.payload?.priority?.new}
                    </span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.owner &&
            item?.payload?.owner?.old &&
            item?.payload?.owner?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Owner')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>
                      {item?.payload?.owner?.old}
                    </span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">
                      {item?.payload?.owner?.new}
                    </span>
                  </div>
                </div>
              </div>
            )}
        </div>
      )}
    </div>
  );
}
export default withTranslation()(Risk);